import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { VOID_FN } from '../../../../../utils';
import { LabeledButton } from '../../common';
import Selectable from '../../common/menu/Selectable';
import SlidableSlide from '../../common/menu/SlidableSlide';
import SlideContent from '../../common/menu/SlideContent';
import { STYLE_REPORT_BTN_STATUS_ACTIVE, STYLE_REPORT_BTN_STATUS_DEFAULT, STYLE_REPORT_BTN_STATUS_DISABLED, STYLE_REPORT_BTN_STATUS_HOVER, STYLE_REPORT_FOOTER } from './styles';

function Reporter({
  source,
  onSelect = VOID_FN,
  onClick = VOID_FN,
  submit: { onSubmit, label: submitLabel },
  active
}) {
  const [val, setVal] = useState(null);

  const handleSelect = (value) => {
    onSelect(value);
    setVal(value === val ? null : value);
  };

  const handleBtnClick = () => {
    if (val) onSubmit(val);
  };

  /* unselect radio button when reporter is not active */
  useEffect(() => (active ? onClick() : setVal(null)), [active]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <section
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: '1',
          overflow: 'hidden'
        }}
      >
        <SlidableSlide>
          <SlideContent>
            {source.map(({ label, value }, i) => (
              <Selectable
                key={label}
                label={label}
                index={i + 1}
                totalCount={source.length}
                active={val === value}
                radioButton
                onSelect={() => handleSelect(value)}
                closeOnActiveSelect={false}
              />
            ))}
          </SlideContent>
        </SlidableSlide>
      </section>

      <section style={STYLE_REPORT_FOOTER}>
        <LabeledButton
          id="btn-report-setting-save"
          label={submitLabel}
          disableFocus={val === null}
          customStyle={val ? STYLE_REPORT_BTN_STATUS_DEFAULT : STYLE_REPORT_BTN_STATUS_DISABLED}
          customActiveStyle={val ? STYLE_REPORT_BTN_STATUS_ACTIVE : {}}
          customHoverStyle={val ? STYLE_REPORT_BTN_STATUS_HOVER : {}}
          onClick={handleBtnClick}
        />
      </section>
    </div>
  );
}

export default Reporter;
